var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavoriteStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.22227 2.13261L8.22062 2.13612L6.49954 5.78795L2.67535 6.37016L2.673 6.37053C1.92493 6.48624 1.31605 7.02259 1.09254 7.73899C0.874483 8.43792 1.04542 9.22119 1.57233 9.75853C1.57241 9.75861 1.57249 9.75869 1.57256 9.75876C1.57261 9.75882 1.57266 9.75887 1.57271 9.75892L4.37507 12.6183L3.71153 16.6711L3.7112 16.6732C3.59272 17.4063 3.88487 18.1638 4.49463 18.6147C5.10593 19.0668 5.92114 19.1258 6.59145 18.7609L6.5957 18.7586L10.0009 16.8838L13.406 18.7586L13.4103 18.7609C14.075 19.1227 14.8938 19.0747 15.5124 18.6107C16.1136 18.1599 16.4096 17.4103 16.2905 16.6732L16.2901 16.6705L15.6239 12.618L18.426 9.75892C18.9488 9.22603 19.1312 8.44131 18.9038 7.73168C18.6779 7.02665 18.079 6.48705 17.3257 6.37053L17.3232 6.37015L13.4961 5.78789L11.7764 2.13914C11.7762 2.13852 11.7759 2.1379 11.7756 2.13729C11.454 1.45091 10.7671 1 9.99782 1C9.22311 1 8.54459 1.45554 8.22227 2.13261Z",
    fill: "#CCDEF7",
    stroke: "#141046",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteStarIcon);
export default __webpack_public_path__ + "static/media/favorite-star-icon.efb3d1c900b540e27d9c5e571385e558.svg";
export { ForwardRef as ReactComponent };